module.exports = __webpack_public_path__ + "static/img/smartControl21.96792706.png";